import { render, staticRenderFns } from "./ClaimCombinationBasket.vue?vue&type=template&id=4158469c&scoped=true&"
import script from "./ClaimCombinationBasket.vue?vue&type=script&lang=js&"
export * from "./ClaimCombinationBasket.vue?vue&type=script&lang=js&"
import style0 from "./ClaimCombinationBasket.vue?vue&type=style&index=0&id=4158469c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4158469c",
  null
  
)

export default component.exports